module.exports = __webpack_public_path__ + "img/no_data@2x.f56b2f7f.png";